import { NavbarDataType } from "@/shared/data/navbar.data";
import Footer, { FooterDataType } from "./Footer";
import { Navbar } from "./Navbar";

interface PageTemplateProps {
  navbarData: NavbarDataType;
  children: React.ReactNode;
  footerData: FooterDataType;
}

export const PageTemplate = ({
  navbarData,
  children,
  footerData,
}: PageTemplateProps) => {
  return (
    <>
      <Navbar navbarData={navbarData} />
      {children}
      <Footer footerData={footerData} />
    </>
  );
};
